export const SELECT_MODAL_LIST = "SELECT_MODAL_LIST"
export const SELECT_MODAL_LIST_SUCCESS = "SELECT_MODAL_LIST_SUCCESS"
export const SELECT_MODAL_LIST_ERROR = "SELECT_MODAL_LIST_ERROR"

export const SELECT_MODAL_SELECTED = "SELECT_MODAL_SELECTED"
export const SELECT_MODAL_SELECTED_SUCCESS = "SELECT_MODAL_SELECTED_SUCCESS"
export const SELECT_MODAL_SELECTED_ERROR = "SELECT_MODAL_SELECTED_ERROR"

export const SELECT_MODAL_UPDATE = "SELECT_MODAL_UPDATE"
export const SELECT_MODAL_UPDATE_SUCCESS = "SELECT_MODAL_UPDATE_SUCCESS"
export const SELECT_MODAL_UPDATE_ERROR = "SELECT_MODAL_UPDATE_ERROR"